import { ListOfProductsBrands } from "./ProductsBrands.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum ProductsBrandsActionsTypes {
  CREATE_REQUEST = "products-brands/CREATE_REQUEST",
  CREATE_FAIL = "products-brands/CREATE_FAIL",
  CREATE_SUCCESS = "products-brands/CREATE_SUCCESS",
  DISMISS_MESSAGE = "products-brands/DISMISS_MESSAGE",
  EDIT_REQUEST = "products-brands/EDIT_REQUEST",
  EDIT_FAIL = "products-brands/EDIT_FAIL",
  EDIT_SUCCESS = "products-brands/EDIT_SUCCESS",
  LIST_REQUEST = "products-brands/LIST_REQUEST",
  LIST_FAIL = "products-brands/LIST_FAIL",
  LIST_SUCCESS = "products-brands/LIST_SUCCESS"
}

export interface ProductsBrandsState {
  isLoadingList: boolean;
  list?: ListOfProductsBrands;
  message?: IMessageBar;
}

interface CreateRequest {
  type: ProductsBrandsActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: ProductsBrandsActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: ProductsBrandsActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: ProductsBrandsActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: ProductsBrandsActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: ProductsBrandsActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: ProductsBrandsActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: ProductsBrandsActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: ProductsBrandsActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: ProductsBrandsActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfProductsBrands;
  };
}

export type ProductsBrandsReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
